import AccountApi from '@ssr/api/account'
import { sendException } from '@ssr/utils'

class Subscription {
  result = undefined
  subscibers = []

  constructor(promise) {
    promise.then((result) => {
      this.result = result
      this.subscibers.forEach((cb) => {
        cb(this.result)
      })
    })
  }

  fetch(cb) {
    if (this.result) {
      cb(this.result)
    } else {
      this.subscibers.push(cb)
    }
  }
}

export const profileSub = new Subscription(
  new Promise((resolve, reject) => {
    const token = AccountApi.getToken()

    if (!token) {
      return resolve({})
    }

    let profile
    try {
      profile = window.sessionStorage.getItem('profile')
      if (profile) {
        profile = JSON.parse(profile)
      }
    } catch (err) {
      console.error(err)
    }

    if (profile) {
      resolve(profile)
    } else {
      AccountApi.getProfile()
        .then((res) => {
          if (res.code === 0) {
            resolve(res.data.account)
          }
        })
    }
  })
)
